import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

import '../../styles/graphics.scss';

const helper = require('../../Helpers/helpers');

type DataPoint = {
    x: string; // Country code
    y: number[]; // Sentiment counts [positive, negative, neutral]
};

type SentimentByCountryProps = {
    data: DataPoint[];
};

function SentimentByCountry({ data }: SentimentByCountryProps) {
    const options: ApexOptions = {
        chart: {
            type: "bar",
            stacked: true,
            toolbar: { show: false },
            height: 350
        },
        xaxis: {
            categories: data.map(({ x }) => helper.getCountryName ? helper.getCountryName(x) || x : x),
            title: { text: "Country" },
            labels: {
                rotate: -45,
                style: {
                    fontSize: '12px'
                }
            }
        },
        yaxis: {
            title: { text: "Number of Reviews" },
            min: 0,
            max: Math.max(...data.map(({ y }) => y.reduce((acc, val) => acc + val, 0)))
        },
        fill: {
            opacity: 0.9,
            type: 'solid'
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['#ffffff']
        },
        colors: ["#22C55E", "#EF4444", "#FBBF24"], // Green for positive, red for negative, yellow for neutral
        tooltip: {
            y: { formatter: (value) => value.toString() },
            x: {
                formatter: (value, { dataPointIndex }) => {
                    const countryCode = data[dataPointIndex]?.x;
                    return helper.getCountryName ? helper.getCountryName(countryCode) || countryCode : countryCode;
                }
            }
        },
        legend: { position: "top" },
        grid: {
            borderColor: "#E5E7EB",
            strokeDashArray: 3
        },
        plotOptions: {
            bar: {
                columnWidth: '100%',
                borderRadius: 6,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'center'
                }
            }
        },
        responsive: [{
            breakpoint: 768,
            options: {
                chart: {
                    height: 300
                },
                xaxis: {
                    labels: {
                        style: {
                            fontSize: '10px'
                        }
                    }
                }
            }
        }]
    };

    const series = [
        {
            name: "Positive",
            data: data.map(({ y }) => y[0]), // Extracting positive sentiment count
        },
        {
            name: "Negative",
            data: data.map(({ y }) => y[1]), // Extracting negative sentiment count
        },
        {
            name: "Neutral",
            data: data.map(({ y }) => y[2]), // Extracting neutral sentiment count
        },
    ];

    return (
        <div className="sentiment-by-country-chart">
            <ReactApexChart
                options={options}
                series={series}
                type="bar"
                height={350}
            />
        </div>
    );
}

export default SentimentByCountry;